import React from 'react';
import { Link } from 'react-router-dom';

import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaEye, FaTrash } from 'react-icons/fa';

class CampaignList extends React.Component {
  render() {
    return (
        <>
            <div className="sectionlist pt-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6 pb-3">
                            <h3>Campaign</h3>
                        </div>
                        <div className="col-md-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                    <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>John</td>
                                    <td>Active</td>
                                    <td>Shubham</td>
                                    <td>14-06-2021</td>
                                    <td><Link to={`/path`} className="buttons update"><FaPencilAlt /> Update</Link>    <Link to={`/path`} className="buttons delete"><FaTrash /> Delete</Link> <Link to={`/path`} className="buttons whtsapp"><FaEye /> View report</Link></td>
                                    </tr>

                                    <tr>
                                    <td>Pol</td>
                                    <td>In-Active</td>
                                    <td>Shubham</td>
                                    <td>14-06-2021</td>
                                    <td><Link to={`/path`} className="buttons update"><FaPencilAlt /> Update</Link>    <Link to={`/path`} className="buttons delete"><FaTrash /> Delete</Link> <Link to={`/path`} className="buttons whtsapp"><FaEye /> View report</Link></td>
                                    </tr>

                                    <tr>
                                    <td>Lisa</td>
                                    <td>Active</td>
                                    <td>Shubham</td>
                                    <td>14-06-2021</td>
                                    <td><Link to={`/path`} className="buttons update"><FaPencilAlt /> Update</Link>    <Link to={`/path`} className="buttons delete"><FaTrash /> Delete</Link> <Link to={`/path`} className="buttons whtsapp"><FaEye /> View report</Link></td>
                                    </tr>

                                    <tr>
                                    <td>Aees</td>
                                    <td>In-Active</td>
                                    <td>Shubham</td>
                                    <td>14-06-2021</td>
                                    <td><Link to={`/path`} className="buttons update"><FaPencilAlt /> Update</Link>    <Link to={`/path`} className="buttons delete"><FaTrash /> Delete</Link> <Link to={`/path`} className="buttons whtsapp"><FaEye /> View report</Link></td>
                                    </tr>

                                    <tr>
                                    <td>San</td>
                                    <td>Active</td>
                                    <td>Shubham</td>
                                    <td>14-06-2021</td>
                                    <td><Link to={`/path`} className="buttons update"><FaPencilAlt /> Update</Link>    <Link to={`/path`} className="buttons delete"><FaTrash /> Delete</Link> <Link to={`/path`} className="buttons whtsapp"><FaEye /> View report</Link></td>
                                    </tr>
                                    
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
  }
}
export default CampaignList;
